import tutorialModelAIcon from "url:shared-assets/images/tutorialModelImages/tutorialModelB.svg";
import { useTranslation } from 'react-i18next';

const ModelB = (prop: any) => {
    const translation = useTranslation();
    const { t } = translation;
    const { currentStepNumber, totalSteps } = prop;
    return (
        <div className="z-modal-content-height">
            <div className="flex flex-col items-center gap-4">
                <img className="w-60 h-60" src={tutorialModelAIcon} alt="tutorialModelB" /></div>
            <div className="space-y-4 w-full h-54">
                <p className="z-title5">{t("step")} {currentStepNumber} {t("of")} {totalSteps}</p>
                <div className="z-heading2 gray-100">{t("modelB-title")}</div>
                <p className="z-body1">{t("modelB-description")}</p></div>
        </div>
    );
};

export default ModelB;